/* Inspireret af — cart line item property catch-all + Assortion drawer display tweaks.
   1) Ensures every cart line gets the "Inspireret af" property (covers app-driven adds,
      e.g. the Assortion cart drawer's own recommendation buttons) by watching all
      /cart/add calls and fixing lines up via /cart/change.js. Values resolve through
      the templates/product.inspireret-af.liquid view and are cached per handle.
      NOTE: the view request must NOT send Accept: application/json — that makes
      Shopify return the product JSON API payload instead of rendering the view.
   2) Restyles Assortion drawer line items: title becomes "TITLE | Inspireret af X"
      (the appended part in normal font weight), the property row is hidden, and the
      "Variant:" label is renamed to "Størrelse:". Display resolves values from the
      product handle (cache + prefetch), so it shows instantly without waiting for
      the background property fix-up. */
(function () {
  'use strict';
  var PROP = 'Inspireret af';
  var origFetch = window.fetch;
  var valueCache = Object.create(null);
  var valuePromises = Object.create(null);

  function getValue(handle) {
    if (!handle) return Promise.resolve('');
    if (!valuePromises[handle]) {
      valuePromises[handle] = origFetch.call(window, '/products/' + handle + '?view=inspireret-af')
        .then(function (r) { return r.ok ? r.text() : '""'; })
        .then(function (t) {
          var v = '';
          try { v = JSON.parse(t); } catch (e) { v = ''; }
          if (typeof v !== 'string') v = '';
          valueCache[handle] = v.trim();
          return valueCache[handle];
        })
        .catch(function () { valueCache[handle] = ''; return ''; });
    }
    return valuePromises[handle];
  }

  function prefetchFromAddResponse(data) {
    try {
      var items = [];
      if (data && data.items && data.items.length) items = data.items;
      else if (data && data.handle) items = [data];
      items.forEach(function (it) {
        if (it && it.handle) { getValue(it.handle).then(scheduleDisplayFix); }
      });
    } catch (e) {}
  }

  var fixQueued = false;
  var fixRunning = false;

  function runFixup() {
    if (fixRunning) { fixQueued = true; return; }
    fixRunning = true;
    fixOnce(0).catch(function () {}).then(function () {
      fixRunning = false;
      if (fixQueued) { fixQueued = false; runFixup(); }
    });
  }

  function fixOnce(iteration) {
    if (iteration >= 10) return Promise.resolve();
    return origFetch.call(window, '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var pending = (cart.items || []).filter(function (it) {
          return !(it.properties && it.properties[PROP]);
        });
        if (!pending.length) return null;
        var idx = 0;
        function next() {
          if (idx >= pending.length) return Promise.resolve(null);
          var it = pending[idx++];
          return getValue(it.handle).then(function (v) {
            if (!v) return next();
            var props = {};
            for (var k in (it.properties || {})) props[k] = it.properties[k];
            props[PROP] = v;
            return origFetch.call(window, '/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: props })
            }).then(function () { return true; });
          });
        }
        return next();
      })
      .then(function (changed) {
        if (changed) return fixOnce(iteration + 1);
      });
  }

  function scheduleFixup() {
    setTimeout(runFixup, 300);
  }

  try {
    window.fetch = function (input) {
      var p = origFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add(\.js)?([\/?]|$)/.test(url)) {
          p.then(function (res) {
            if (res && res.ok) {
              scheduleFixup();
              try { res.clone().json().then(prefetchFromAddResponse).catch(function () {}); } catch (e) {}
            }
          }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  } catch (e) {}

  try {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__iaUrl = url;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      try {
        if (this.__iaUrl && /\/cart\/add(\.js)?([\/?]|$)/.test(String(this.__iaUrl))) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 300) {
              scheduleFixup();
              try { prefetchFromAddResponse(JSON.parse(this.responseText)); } catch (e) {}
            }
          });
        }
      } catch (e) {}
      return origSend.apply(this, arguments);
    };
  } catch (e) {}

  function applyInspireret(title, value) {
    if (!value || !title || title.dataset.inspireretDone) return;
    title.dataset.inspireretDone = '1';
    var span = document.createElement('span');
    span.style.fontWeight = 'normal';
    span.textContent = ' | Inspireret af ' + value;
    title.appendChild(span);
  }

  function fixCartDisplay() {
    document.querySelectorAll('.ast-cart__item__product-info').forEach(function (info) {
      info.querySelectorAll('.ast-cart__item__option-name').forEach(function (n) {
        if (/^\s*Variant\s*:/.test(n.textContent)) n.textContent = 'Størrelse: ';
      });
      var title = info.querySelector('.ast-cart__item__title');
      var prop = Array.prototype.find.call(info.querySelectorAll('.ast-cart__item__property'), function (p) {
        var name = p.querySelector('.ast-cart__item__property-name');
        return name && /^\s*Inspireret af\s*:/.test(name.textContent);
      });
      var propValue = '';
      if (prop) {
        var valueEl = prop.querySelector('.ast-cart__item__property-value');
        propValue = valueEl ? valueEl.textContent.trim() : '';
        prop.style.display = 'none';
      }
      if (!title || title.dataset.inspireretDone) return;
      if (propValue) { applyInspireret(title, propValue); return; }
      var href = title.getAttribute('href') || '';
      var m = href.match(/\/products\/([^\/?#]+)/);
      if (!m) return;
      var handle = m[1];
      if (handle in valueCache) { applyInspireret(title, valueCache[handle]); return; }
      getValue(handle).then(function (v) { applyInspireret(title, v); });
    });
  }

  var rafPending = false;
  function scheduleDisplayFix() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      try { fixCartDisplay(); } catch (e) {}
    });
  }

  function init() {
    try { fixCartDisplay(); } catch (e) {}
    try {
      new MutationObserver(scheduleDisplayFix).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    scheduleFixup();
    try {
      origFetch.call(window, '/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          (cart.items || []).forEach(function (it) { if (it.handle) getValue(it.handle); });
        })
        .catch(function () {});
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
